import { useEffect, useMemo, useState } from 'react';

import { apiService } from '@/lib/axios';

export default function useCognitoUsers() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);

  const userMaps = useMemo(
    () =>
      users.reduce((mapping, item) => {
        mapping[item.sub] = {
          email: item.email,
          groups: item.groups,
          name: item.name,
        };

        return mapping;
      }, {}),
    [users]
  );

  const getBySub = (sub) => userMaps[sub];

  useEffect(() => {
    apiService.users
      .getCognitoUsers()
      .then((res) => {
        if (res.data.success) {
          setUsers(
            res.data.data.map(
              ({
                department = '',
                designation = '',
                email,
                groups = [],
                name,
                sub,
              }) => ({
                designation,
                department,
                email,
                groups,
                label: name,
                name,
                sub,
                value: sub,
              })
            )
          );
        } else {
          const msg = 'getCognitoUsers returned success=false';

          console.warn(msg, res.data);

          setError(msg);
        }
      })
      .catch((err) => {
        const msg = err.message || String(err);

        console.error('Failed to fetch Cognito users:', msg);

        setError(msg);
      });
  }, []);

  return { getBySub, users, error };
}
